<template>
  <div class="page">
    <website-landing />
    <project-gallery />
    <about-me />
    <footer class="footer text-smaller text_align_center">
      All works@Poulami {{ year }}
    </footer>
  </div>
</template>

<script>
import lazyLoadComponent from '../utils/lazy-components'
import WebsiteLanding from '../components/home/WebsiteLanding.vue'
import SkeletonBox from '../components/childComps/SkeletonBox.vue'

const defaultOptions = {
  loading: SkeletonBox
}
export default {
  components: {
    SkeletonBox,
    WebsiteLanding,
    ProjectGallery: lazyLoadComponent({
      ...defaultOptions,
      componentFactory: () => import(`../components/home/ProjectGallery.vue`)
    }),

    AboutMe: () => import('../components/home/AboutMe.vue')
  },
  computed: {
    year: () => {
      let today = new Date()
      return today.getFullYear()
    },
  },
}
</script>

<style></style>
